
export default {
    props: [
        'title',
        'explanation',
        'styleClass',
        'alert',
        'explanationLinkTo',
        'inputRequire'
    ],
    data: () => {
        return {
        }
    },
    mounted: function() {
    }
};
